import React, {useState} from 'react';
import {Button, Form, Input, message} from 'antd';
import {UserOutlined, LockOutlined} from '@ant-design/icons';
import {useNavigate} from 'react-router-dom';
import {getJson} from '@/util/ajaxUtils';
import {useAuthStore} from '@/context/auth';
import useTitle from '@/hook/useTitle';

import styles from './DevLoginPage.module.less';

export default function DevLoginPage() {
    useTitle('开发登录');
    const [loading, setLoading] = useState(false);
    const [, dispatch] = useAuthStore();
    const navigate = useNavigate();

    async function onFinish(values) {
        setLoading(true);
        try {
            const res = await getJson('/auth/dev-login', {
                params: {email: values.email, password: values.password},
                custom: {noAuth: true, showErrorNotification: false},
            });
            if (res && res.data) {
                dispatch(['loginSuccess', res.data]);
                message.success('登录成功');
                navigate('/', {replace: true});
            } else {
                message.error((res && res.message) || '登录失败');
            }
        } catch (e) {
            message.error(e.message || '登录失败');
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <h1 className={styles.title}>开发环境登录</h1>
                <Form onFinish={onFinish} size="large">
                    <Form.Item
                        name="email"
                        rules={[{required: true, message: '请输入邮箱'}]}
                    >
                        <Input prefix={<UserOutlined />} placeholder="邮箱" />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        rules={[{required: true, message: '请输入密码'}]}
                    >
                        <Input.Password prefix={<LockOutlined />} placeholder="密码" />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" loading={loading} block>
                            登录
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
}